import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Power, Wrench } from "lucide-react";
import { api, C } from "../../lib/api";
import { Card, Field, inputCls, fmtWhen } from "./ui";

// Kill switch: no new hands anywhere (live hands finish), no new seats / registrations, notice on every screen.
export const MaintenancePanel = () => {
  const [state, setState] = useState(null);
  const [message, setMessage] = useState("");
  const load = () => api.get(C.ApiRoutes.MAINTENANCE).then((r) => { setState(r.data); setMessage(r.data.message || ""); }).catch(() => {});
  useEffect(() => { load(); }, []);
  const toggle = async (on) => {
    try {
      const { data } = await api.post(C.ApiRoutes.MAINTENANCE, { on, message });
      setState(data);
      toast[on ? "warning" : "success"](on ? "Maintenance ON — tables finish their current hand and stop" : "Maintenance lifted — play resumes");
    } catch { toast.error("Could not change maintenance state"); }
  };
  return (
    <Card title="Maintenance switch" testId="maintenance-panel">
      <div className="flex flex-col gap-4">
        <div className="flex items-center gap-3">
          <span data-testid="maintenance-state" className={`rounded-full px-3 py-1 text-xs font-display tracking-wider ${state?.on ? "bg-amber-500 text-slate-900" : "bg-emerald-500/20 text-emerald-200"}`}>
            {state?.on ? "ON — tables paused" : "OFF — live"}
          </span>
          {state?.on && <span className="text-xs text-slate-400">since {fmtWhen(state.since)}</span>}
        </div>
        <Field label="Notice shown to players" hint="Live hands always finish; nobody can sit, re-buy or register until it is lifted.">
          <input data-testid="maintenance-message" className={inputCls} value={message} onChange={(e) => setMessage(e.target.value)} maxLength={200} placeholder="e.g. Deck audit in progress — back in 10 minutes" />
        </Field>
        <div className="flex gap-3">
          <button data-testid="maintenance-on" onClick={() => toggle(true)} disabled={state?.on} className="rounded-full px-5 py-2 text-xs font-display tracking-wider bg-amber-500 text-slate-900 btn-lift disabled:opacity-40 flex items-center gap-2"><Wrench className="w-4 h-4" /> Pause everything</button>
          <button data-testid="maintenance-off" onClick={() => toggle(false)} disabled={!state?.on} className="rounded-full px-5 py-2 text-xs font-display tracking-wider bg-emerald-500 text-slate-900 btn-lift disabled:opacity-40 flex items-center gap-2"><Power className="w-4 h-4" /> Resume play</button>
        </div>
      </div>
    </Card>
  );
};
